import React, { Component } from "react";
import {
  Dropdown as ReactStrapDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import PropTypes from "prop-types";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedValue: props.name
    };
  }

  toggle = () => {
    const { dropdownOpen } = this.state;
    this.setState({
      dropdownOpen: !dropdownOpen
    });
  };

  selectedItem = (item) => {
    const { selectedItemCallback } = this.props;
    this.setState({
      selectedValue: item.text
    });
    selectedItemCallback(item.value);
  };

  render() {
    const {
      state: { dropdownOpen, selectedValue },
      toggle,
      selectedItem,
      props: { items, name }
    } = this;
    return (
      <div className="dropdown-container">
        <ReactStrapDropdown
          direction="down"
          isOpen={dropdownOpen}
          toggle={toggle}
        >
          <DropdownToggle caret defaultValue={name}>
            {selectedValue}
          </DropdownToggle>
          <DropdownMenu
            flip={false}
            modifiers={{
              setMaxHeight: {
                enabled: true,
                fn: (data) => ({
                  ...data,
                  styles: {
                    ...data.styles,
                    overflow: "auto",
                    maxHeight: "500px"
                  }
                })
              }
            }}
          >
            {items.map((item) => (
              <DropdownItem
                key={`${name}-dropdown-item-${item.value}`}
                onClick={() => selectedItem(item)}
              >
                {item.text}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </ReactStrapDropdown>
      </div>
    );
  }
}

Dropdown.propTypes = {
  selectedItemCallback: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired
};

export default Dropdown;
